import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { Goicuoc5gAction } from 'src/actions/goicuoc5g.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  OPERATOR_THEME,
  CU_PHAP_DANG_KY_GOI_CUOC,
} from 'src/utils/constants';
import { getGoicuoc5gStatus } from 'src/utils/utils';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Select,
  MenuItem,
  InputAdornment,
  SvgIcon,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import { Outlet, Link, useNavigate, useLocation, useParams } from "react-router-dom";

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import DangKyGoiCuocDialog from './DangKyGoiCuocDialog';

import goiCuocHeadMobifone from "../../assets/images/goiCuocHeadMobifone.svg";
import goiCuocHeadVinaphone from "../../assets/images/goiCuocHeadVinaphone.svg";
import goiCuocHeadViettel from "../../assets/images/goiCuocHeadViettel.svg";
import goiCuocHeadHot from "../../assets/images/goiCuocHeadHot.svg";

const TheHomepageGoicuoc5gDetail = ({ ...rest }) => {
  const { operator } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = queryParams.get("page");
  const [selectedGoicuoc5gIds, setSelectedGoicuoc5gIds] = useState([]);
  const [homepageGoicuoc5gLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE);
  const [homepageGoicuoc5gPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageGoicuoc5gItems, homepageGoicuoc5gTotal, homepageGoicuoc5gFilter } = useSelector(state => state.goicuoc5g);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile);
  const { isLoading } = useSelector(state => state.app);
  const [name, setName] = useState("");
  const [price_select, setPriceSelect] = useState("-99");
  const [number_type_0, setNumberType0] = useState(2);
  const [number_type_1, setNumberType1] = useState(2);
  const [time_by_day_select, setTimeByDaySelect] = useState("-99");
  const [loai_goi_cuoc_select, setLoaiGoiCuocSelect] = useState("-99");
  const [values, setValues] = useState({
    operator: operator.toUpperCase(),
    name: "",
    price_min: "",
    price_max: "",
    number_type: "-99",
    time_by_day_min: "",
    time_by_day_max: "",
    loai_goi_cuoc: [],
  });
  const operatorTheme = typeof OPERATOR_THEME[operator] !== 'undefined' ? OPERATOR_THEME[operator] : null;

  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])

  useEffect(() => {
    setName("");
    setPriceSelect("-99");
    setNumberType0(2);
    setNumberType1(2);
    setTimeByDaySelect("-99");
    setLoaiGoiCuocSelect("-99");

    const payload = {
      ...homepageGoicuoc5gFilter,
      homepageGoicuoc5gLimit: DEFAULT_HOMEPAGE_ROW_PER_PAGE,
      homepageGoicuoc5gPage: 0,
      operator: operator.toUpperCase(),
      name: "",
      price_min: "",
      price_max: "",
      number_type: "-99",
      time_by_day_min: "",
      time_by_day_max: "",
      loai_goi_cuoc: [],
    };
    dispatch(Goicuoc5gAction.updateHomepageFilter(payload));
    dispatch(Goicuoc5gAction.homepageList())
  }, [operator])
  
  useEffect(() => {
    const payload = {
      ...homepageGoicuoc5gFilter,
      homepageGoicuoc5gLimit: homepageGoicuoc5gLimit,
      homepageGoicuoc5gPage: homepageGoicuoc5gPage,
      operator: operator.toUpperCase(),
    };
    dispatch(Goicuoc5gAction.updateHomepageFilter(payload));
    dispatch(Goicuoc5gAction.homepageList())
  }, [homepageGoicuoc5gPage, homepageGoicuoc5gLimit])

  const onLookup = () => {
    let _name = "";
    let _price_min = "0";
    let _price_max = "999999999";
    let _number_type = "-99";
    let _time_by_day_min = "0";
    let _time_by_day_max = "999999999";
    let _loai_goi_cuoc = [];

    _name = name;

    //==========

    if (price_select == "1") {
      _price_min = "0";
      _price_max = "49999";
    } else if (price_select == "2") {
      _price_min = "50000";
      _price_max = "100000";
    } else if (price_select == "3") {
      _price_min = "100000";
      _price_max = "200000";
    } else if (price_select == "4") {
      _price_min = "200000";
      _price_max = "500000";
    } else if (price_select == "5") {
      _price_min = "500000";
      _price_max = "1000000";
    } else if (price_select == "6") {
      _price_min = "1000001";
      _price_max = "999999999";
    }

    //==========

    if (number_type_0 == "1" && number_type_1 != "1") {
      _number_type = "1";
    } else if (number_type_0 != "1" && number_type_1 == "1") {
      _number_type = "2";
    } else if (number_type_0 == "1" && number_type_1 == "1") {
      _number_type = "3";
    }

    //==========

    if (time_by_day_select == "1") {
      _time_by_day_min = "0";
      _time_by_day_max = "6";
    } else if (time_by_day_select == "2") {
      _time_by_day_min = "7";
      _time_by_day_max = "30";
    } else if (time_by_day_select == "3") {
      _time_by_day_min = "30";
      _time_by_day_max = "90";
    } else if (time_by_day_select == "4") {
      _time_by_day_min = "90";
      _time_by_day_max = "180";
    } else if (time_by_day_select == "5") {
      _time_by_day_min = "180";
      _time_by_day_max = "270";
    } else if (time_by_day_select == "6") {
      _time_by_day_min = "270";
      _time_by_day_max = "360";
    } else if (time_by_day_select == "7") {
      _time_by_day_min = "361";
      _time_by_day_max = "999999999";
    }

    //==========

    if (loai_goi_cuoc_select == "1") {
      _loai_goi_cuoc = [
        "goi_hot",
      ]
    } else if (loai_goi_cuoc_select == "4") {
      _loai_goi_cuoc = [
        "data",
      ]
    } else if (loai_goi_cuoc_select == "5") {
      _loai_goi_cuoc = [
        "thoai_va_sms",
      ]
    }

    //==========

    const payload = {
      homepageGoicuoc5gPage: 'no_update',
      homepageGoicuoc5gLimit: 'no_update',
      operator: operator.toUpperCase(),
      name: _name,
      price_min: _price_min,
      price_max: _price_max,
      number_type: _number_type,
      time_by_day_min: _time_by_day_min,
      time_by_day_max: _time_by_day_max,
      loai_goi_cuoc: _loai_goi_cuoc,
    };
    console.log(payload);
    dispatch(Goicuoc5gAction.updateHomepageFilter(payload));
    dispatch(Goicuoc5gAction.homepageList())
  };

  const handleInputChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const handleSelectAll = (event) => {
    let newSelectedGoicuoc5gIds;

    if (event.target.checked) {
      newSelectedGoicuoc5gIds = homepageGoicuoc5gItems.map((goicuoc5g) => goicuoc5g.id);
    } else {
      newSelectedGoicuoc5gIds = [];
    }

    setSelectedGoicuoc5gIds(newSelectedGoicuoc5gIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedGoicuoc5gIds.indexOf(id);
    let newSelectedGoicuoc5gIds = [];

    if (selectedIndex === -1) {
      newSelectedGoicuoc5gIds = newSelectedGoicuoc5gIds.concat(selectedGoicuoc5gIds, id);
    } else if (selectedIndex === 0) {
      newSelectedGoicuoc5gIds = newSelectedGoicuoc5gIds.concat(selectedGoicuoc5gIds.slice(1));
    } else if (selectedIndex === selectedGoicuoc5gIds.length - 1) {
      newSelectedGoicuoc5gIds = newSelectedGoicuoc5gIds.concat(selectedGoicuoc5gIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedGoicuoc5gIds = newSelectedGoicuoc5gIds.concat(
        selectedGoicuoc5gIds.slice(0, selectedIndex),
        selectedGoicuoc5gIds.slice(selectedIndex + 1)
      );
    }

    setSelectedGoicuoc5gIds(newSelectedGoicuoc5gIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);

    // Gán giá trị mặc định
    queryParams.set("page", newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, goicuoc5g) => {
    setSelected(goicuoc5g);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(Goicuoc5gAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(Goicuoc5gAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageGoicuoc5gTotal / homepageGoicuoc5gLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageGoicuoc5gPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageGoicuoc5gPage - 2); i <= Math.min(totalPages - 1, homepageGoicuoc5gPage + 2); i++) {
              pages.push(i);
          }
          if (homepageGoicuoc5gPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageGoicuoc5gPage || page === "..."} style={{
                  padding: "8px 12px", background: page === homepageGoicuoc5gPage ? "var(--main-color)" : "var(--main-color)", color: "#fff",
                  border: "none", borderRadius: "5px", cursor: page === homepageGoicuoc5gPage || page === "..." ? "default" : "pointer",
                  margin: "0", transition: "0.3s"
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // hoặc 'auto'
    });
  };

  const xemChiTiet = (id) => {
    navigate(`/trang-chu/goi-cuoc/${operator}/${id}`)
  };

  const dangKy = (id) => {
    dispatch(Goicuoc5gAction.homepageFindOne(id));
    setOpen(true);
  };

  return (
    <>
        <Helmet>
          <title>Gói cước {operator.toUpperCase()} | Gói cước - Di Dong Telecom</title>
        </Helmet>

        <div
          className="goicuoc-search-region"
          style={{
            backgroundColor: "#f9f9f9",
            padding: "0 0 20px 0",
            borderRadius: "8px",
            fontFamily: "Mulish, sans-serif",
          }}
        >
          <p
            style={{
              paddingTop: "20px",
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "30px",
              color: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000',
            }}
          >
            TÌM KIẾM GÓI CƯỚC
          </p>

          <div
            className="search_mobi"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: "95%",
              margin: "0 auto",
              marginBottom: "15px",
            }}
          >
            {/* Dòng 1: Tìm gói, loại gói, checkbox */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
              }}
            >
              {/* Tìm gói cước */}
              <div style={{ flex: "1 1 300px", minWidth: "260px" }}>
                <label style={{ fontWeight: "bold", fontSize: "16px", display: "block", marginBottom: "5px" }}>
                  Tìm gói cước
                </label>
                <input
                  type="text"
                  placeholder="Nhập tên gói cước"
                  name="name"
                  value={name}
                  onChange={(e) => {setName(e.target.value)}}
                  onKeyDown={handleKeyDown}
                  style={{
                    width: "100%",
                    padding: "10px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </div>

              {/* Loại gói cước */}
              <div style={{ flex: "1 1 300px", minWidth: "260px" }}>
                <label style={{ fontWeight: "bold", fontSize: "16px", display: "block", marginBottom: "5px" }}>
                  Loại gói cước
                </label>
                <Select
                  style={{
                    width: "100%",
                    height: "40px",
                    // padding: "10px",
                    fontSize: "16px",
                    // border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "#FFF",
                  }}
                  name="loai_goi_cuoc_select"
                  value={loai_goi_cuoc_select || "-99"}
                  onChange={(e) => {setLoaiGoiCuocSelect(e.target.value)}}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                >
                  <MenuItem value="-99">Loại gói cước</MenuItem>
                  <MenuItem value="1">Gói hot</MenuItem>
                  <MenuItem value="4">Data</MenuItem>
                  <MenuItem value="5">Thoại & SMS</MenuItem>
                </Select>
              </div>

              {/* Trả trước / Trả sau */}
              <div style={{ flex: "1 1 300px", minWidth: "260px" }}>
                <label style={{ fontWeight: "bold", fontSize: "16px", display: "block", marginBottom: "5px" }}>
                  Loại thuê bao
                </label>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                    paddingTop: "10px",
                  }}
                >
                  <label 
                    onChange={(e) => setNumberType0(number_type_0 == 1 ? 2 : 1)}
                    style={{ fontWeight: 400, display: "flex", alignItems: "center" }}
                  >
                    <input 
                      checked={number_type_0 == 1 ? true : false}
                      value={number_type_0 == 1 ? 1 : 2}
                      type="checkbox" style={{ marginRight: "5px" }} 
                    />
                    Trả trước
                  </label>
                  <label 
                    onChange={(e) => setNumberType1(number_type_1 == 1 ? 2 : 1)}
                    style={{ fontWeight: 400, display: "flex", alignItems: "center" }}
                  >
                    <input 
                      checked={number_type_1 == 1 ? true : false}
                      value={number_type_1 == 1 ? 1 : 2}
                      type="checkbox" style={{ marginRight: "5px" }} 
                    />
                    Trả sau
                  </label>
                </div>
              </div>
            </div>

            {/* Dòng 2: Khoảng giá + Chu kỳ */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
              }}
            >
              {/* Khoảng giá */}
              <div style={{ flex: "1 1 300px", minWidth: "260px" }}>
                <label style={{ fontWeight: "bold", fontSize: "16px", display: "block", marginBottom: "5px" }}>
                  Khoảng giá (VNĐ)
                </label>
                <Select
                  style={{
                    width: "100%",
                    height: "40px",
                    // padding: "10px",
                    fontSize: "16px",
                    // border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "#FFF",
                  }}
                  name="price_select"
                  value={price_select || "-99"}
                  onChange={(e) => {setPriceSelect(e.target.value)}}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                >
                  <MenuItem value="-99">Tất cả</MenuItem>
                  <MenuItem value="1">Dưới 50k</MenuItem>
                  <MenuItem value="2">Từ 50k - 100k</MenuItem>
                  <MenuItem value="3">Từ 100k - 200k</MenuItem>
                  <MenuItem value="4">Từ 200k - 500k</MenuItem>
                  <MenuItem value="5">Từ 500k - 1000k</MenuItem>
                  <MenuItem value="6">Trên 1000k</MenuItem>
                </Select>
              </div>

              {/* Chu kỳ */}
              <div style={{ flex: "1 1 300px", minWidth: "260px" }}>
                <label style={{ fontWeight: "bold", fontSize: "16px", display: "block", marginBottom: "5px" }}>
                  Chu kỳ (Ngày)
                </label>
                <Select
                  style={{
                    width: "100%",
                    height: "40px",
                    // padding: "10px",
                    fontSize: "16px",
                    // border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "#FFF",
                  }}
                  name="time_by_day_select"
                  value={time_by_day_select || "-99"}
                  onChange={(e) => {setTimeByDaySelect(e.target.value)}}
                  onKeyDown={handleKeyDown}
                  variant="outlined"
                >
                  <MenuItem value="-99">Tất cả</MenuItem>
                  <MenuItem value="1">Dưới 7 ngày</MenuItem>
                  <MenuItem value="2">Từ 7 - 30 ngày</MenuItem>
                  <MenuItem value="3">Từ 30 - 90 ngày</MenuItem>
                  <MenuItem value="4">Từ 90 - 180 ngày</MenuItem>
                  <MenuItem value="5">Từ 180 - 270 ngày</MenuItem>
                  <MenuItem value="6">Từ 270 - 360 ngày</MenuItem>
                  <MenuItem value="7">Trên 360 ngày</MenuItem>
                </Select>
              </div>
            </div>

            {/* Dòng 3: Nút tìm kiếm */}
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <button
                className='btn-search btn-has-icon'
                type="button"
                onClick={onLookup}
                style={{
                  width: 80,
                  height: 40,
                  backgroundColor: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000',
                  color: "#fff",
                  padding: "10px 30px",
                  fontSize: "24px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  transform: "rotateY(-180deg)",
                }}
              >
                ⌕
              </button>
            </div>
          </div>
        </div>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className={`goicuoc5g-list-show ${operator.toUpperCase()}`} style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px" }}>
            {homepageGoicuoc5gItems && homepageGoicuoc5gItems.slice(homepageGoicuoc5gPage * homepageGoicuoc5gLimit, homepageGoicuoc5gPage * homepageGoicuoc5gLimit + homepageGoicuoc5gLimit).map((goicuoc5g, index) => (
                goicuoc5g ? <div class={`goicuoc5g-item ${operator.toUpperCase()} list_Sim`}>
                  {goicuoc5g.tam_dung == 1 && <div class="pause-stamp">TẠM DỪNG</div>}

                  <p class="list_Sim_1 ng-binding">{goicuoc5g.name}</p>
                  <img class="img_cong" src={operator.toUpperCase() == 'MOBIFONE' ? goiCuocHeadMobifone : (operator.toUpperCase() == 'VINAPHONE' ? goiCuocHeadVinaphone : goiCuocHeadViettel)} alt="" />
                  {goicuoc5g.types?.some(type => type.loai_goi_cuoc === 'goi_hot') && (
                    <img class="sim_hot ng-scope" src={goiCuocHeadHot} alt="" />
                  )}
                  <div class="list_Sim_23">
                    <p class="boder_dotted ng-binding">{goicuoc5g.short_description}</p>
                    <p class="boder_dotted ng-binding">
                      {(Number(goicuoc5g.price_new) > 0 && Number(goicuoc5g.price_new) < Number(goicuoc5g.price)) ? (
                        <div>
                          <span style={{ color: 'red', fontWeight: 'bold' }}>
                            {numeral(goicuoc5g.price_new).format('0,0')}₫
                          </span>
                          <br></br>
                          <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                            {numeral(goicuoc5g.price).format('0,0')}₫
                          </span>
                        </div>
                      ) : (
                        <div>
                          <span style={{ fontWeight: 'bold' }}>
                            {numeral(goicuoc5g.price).format('0,0')}₫
                          </span>
                        </div>
                      )}
                    </p>
                    <p class="ng-binding">{goicuoc5g.time_by_day} ngày</p>
                  </div>
                  <div class="row">
                    <div class="left hide_menu_mobi">
                      <label style={{borderColor: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000', color: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000'}} class="btn2" id="btn_right1" onClick={() => xemChiTiet(goicuoc5g.slug)}>Chi tiết</label>
                    </div>
                    <div class={`right ${goicuoc5g.tam_dung == 1 ? "disable" : ''}`}>
                      <label style={{borderColor: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000', background: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000'}} class="btn1" id="btn_left1" onClick={() => dangKy(goicuoc5g.slug)}>Đăng ký</label>
                    </div>
                  </div>
              </div> : null
            ))}
        </div>}

        {!isLoading && <div className='list-pagination' style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "5px" }}>
            <button onClick={(e) => handlePageChange(e, homepageGoicuoc5gPage - 1)} disabled={homepageGoicuoc5gPage === 0} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {"<"}
            </button>
            {renderPagination()}
            <button onClick={(e) => handlePageChange(e, homepageGoicuoc5gPage + 1)} disabled={homepageGoicuoc5gPage + 1 >= homepageGoicuoc5gTotal / homepageGoicuoc5gLimit} style={{ padding: "10px 15px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", transition: "0.3s" }}
            onMouseEnter={e => e.target.style.background = "var(--main-color)"}
            onMouseLeave={e => e.target.style.background = "var(--main-color)"}>
                {">"}
            </button>
        </div>}

        <DangKyGoiCuocDialog open={open} handleClose={handleClose} type={"EDIT"} />
    </>
  );
};

export default TheHomepageGoicuoc5gDetail;
